export function client(data) {
    const { custom } = data;

    const {
        has_kids,
        family_status,
        family_status_required,
        family_status_own_variants,
        family_status_save_own_variants,
    } = custom || {};
    return {
        personalData: {
            hasChildren: !!has_kids,
            familyStatus: {
                show: !!family_status,
                required: !!family_status_required,
                custom: !!family_status_own_variants,
                saveCustom: !!family_status_save_own_variants,
            },
        },
    };
}

export function server(data) {
    const { hasChildren, familyStatus } = data.personalData;
    const { show, required, custom, saveCustom } = familyStatus;
    return {
        custom: {
            has_kids: hasChildren,
            family_status: show,
            family_status_required: required,
            family_status_own_variants: custom,
            family_status_save_own_variants: saveCustom,
        },
    };
}
